import { render, staticRenderFns } from "./UserVerification.vue?vue&type=template&id=5077117f&"
import script from "./UserVerification.vue?vue&type=script&lang=js&"
export * from "./UserVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports